import {
  Button,
  ButtonGroup,
  H2,
  Modal,
} from "@datapay-by-datacom/design-system";
import { useState } from "react";
import { OrgUserSummary } from "../../types";
import s from "./AddMemberModal.module.css";

interface AddMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (userId: string) => void;
  isPending: boolean;
  availableUsers: OrgUserSummary[];
}

export function AddMemberModal({
  isOpen,
  onClose,
  onAdd,
  isPending,
  availableUsers,
}: AddMemberModalProps) {
  const [selectedUserId, setSelectedUserId] = useState("");

  const handleAdd = () => {
    if (!selectedUserId) return;
    onAdd(selectedUserId);
    setSelectedUserId("");
  };

  const handleClose = () => {
    setSelectedUserId("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <div className={s.modal}>
        <H2>Add Member</H2>
        <p className={s.description}>Select a user to add to this group.</p>

        <div className={s.field}>
          <label className={s.label} htmlFor="user-select">
            User
          </label>
          <select
            id="user-select"
            className={s.select}
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            disabled={isPending}
          >
            <option value="">Select a user...</option>
            {availableUsers.map((user) => (
              <option key={user.user_id} value={user.user_id}>
                {user.name || user.email || user.user_id}
              </option>
            ))}
          </select>
          {availableUsers.length === 0 && (
            <p className={s.hint}>
              All users are already members of this group.
            </p>
          )}
        </div>

        <ButtonGroup>
          <Button
            variant="tertiary"
            onPress={handleClose}
            isDisabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onPress={handleAdd}
            isDisabled={!selectedUserId || isPending}
          >
            {isPending ? "Adding..." : "Add Member"}
          </Button>
        </ButtonGroup>
      </div>
    </Modal>
  );
}
